import React from 'react';
import { Outlet, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Layout.css';

export function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <h1 className="header-title" onClick={() => navigate('/dashboard')}>
            Schulungsportal
          </h1>
          <div className="header-right">
            {user?.isAdmin && (
              <Link to="/admin" className="admin-link">
                Admin
              </Link>
            )}
            <span className="user-info">
              {user?.admin ? (
                <span className="admin-badge">{user.admin.name}</span>
              ) : user?.organization ? (
                <span className="org-badge">{user.organization.name}</span>
              ) : null}
            </span>
            <button className="logout-btn" onClick={handleLogout}>
              Abmelden
            </button>
          </div>
        </div>
      </header>
      <main className="main-content">
        <Outlet />
      </main>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Schulungsportal</p>
      </footer>
    </div>
  );
}

export default Layout;
